import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  InvestmentContainer,
  InvestmentTopCard,
  InvestmentBalanceCard,
  InvestmentBalanceButton,
  MachineCardContainer,
  MachineCard,
  MachineCardImg,
  MachineValueText,
} from "./Investment.styled";
import { useDispatch, useSelector } from "react-redux";
import { getMachines } from "../../feature/machine/MachineActions";
import { getMinersOwned } from "../../feature/minersOwned/MinersOwnedActions";
import MachineBuy from "./MachineBuy";

const Investment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { machines } = useSelector((state) => state.machine);
  // const { minersOwned } = useSelector((state) => state.minersOwned);
  const [showMachineBuy, setShowMachineBuy] = useState(false);
  const [selectedMachine, setSelectedMachine] = useState({});

  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(getMachines({}));
    Object.keys(user).length && dispatch(getMinersOwned({ user: user }));
  }, [dispatch, user]);

  return (
    <>
      <InvestmentContainer>
        <InvestmentTopCard>
          <InvestmentBalanceCard>
            <InvestmentBalanceButton onClick={() => navigate("/miners-owned")}>
              Miners
              {/* <h2 style={{ lineHeight: "1px" }}>{minersOwned.length}</h2> */}
            </InvestmentBalanceButton>
            <InvestmentBalanceButton onClick={() => navigate("/balance")}>
              Balance
            </InvestmentBalanceButton>
            <InvestmentBalanceButton onClick={() => navigate("/guide")}>
              Guide
            </InvestmentBalanceButton>
          </InvestmentBalanceCard>
        </InvestmentTopCard>
        <MachineCardContainer>
          {machines
            .filter((data, index) => data.available === true)
            .map((data, index, row) => (
              <MachineCard
                onClick={() => {
                  setShowMachineBuy(true);
                  setSelectedMachine(data);
                }}
                key={index}
              >
                <div>
                  <MachineCardImg alt={`machine${index}`} src={data.image} />
                  <div>
                    Revenue{" "}
                    <MachineValueText>{data.daily_profit} TRX</MachineValueText>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    <div>{data.name}</div>
                    <MachineValueText style={{ marginBottom: "5px" }}>
                      {data.price} TRX
                    </MachineValueText>
                  </div>
                  <div>
                    <div>1 year profit</div>
                    <MachineValueText style={{ marginBottom: "5px" }}>
                      {data.earning_sequence === 12
                        ? `${(data.daily_profit * 2 * 365).toFixed(2)} TRX`
                        : `${(data.daily_profit * 365).toFixed(2)} TRX`}
                    </MachineValueText>
                  </div>
                  <div>
                    <div>30 days profit</div>
                    <MachineValueText style={{ marginBottom: "5px" }}>
                      {data.earning_sequence === 12
                        ? `${(data.daily_profit * 2 * 30).toFixed(2)} TRX`
                        : `${(data.daily_profit * 30).toFixed(2)} TRX`}
                    </MachineValueText>
                  </div>
                  <div>
                    <div>Earning cycle</div>
                    <MachineValueText style={{ marginBottom: "5px" }}>
                      {data.earning_sequence} hour
                    </MachineValueText>
                  </div>
                </div>
              </MachineCard>
            ))}
        </MachineCardContainer>
      </InvestmentContainer>
      <MachineBuy
        showMachineBuy={showMachineBuy}
        setShowMachineBuy={setShowMachineBuy}
        selectedMachine={selectedMachine}
      />
    </>
  );
};

export default Investment;
